import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';

import piwik from '@/piwik/piwik';

import { useLinkProducer } from '@domain/app';
import useText from '@hooks/use-text';
import { getVisaCalculatorUrl } from '@utils/url/get-url-utils';

export default () => {
    const { visaCalculatorRedirectButtonTitle, visaCalculatorMainDescription } = useText();
    const linkProducer = useLinkProducer();

    return (
        <LinkCard
            data-track-id={piwik.cardOverview.otherActionVisaCalculator.dataTrackId}
            data-track-linkname={piwik.cardOverview.otherActionVisaCalculator.dataTrackLinkname}
            icon={IconTypes.KALKULATOR_36}
            id="link-visa-fx-simple-calculator"
            textOne={visaCalculatorMainDescription}
            title={visaCalculatorRedirectButtonTitle}
            url={getVisaCalculatorUrl(linkProducer)}
        />
    );
};
